"use strict";
/**
 * Money string parsing (HAN-452).
 * Default locale is en-SG: `,` = thousands, `.` = decimal.
 * Also accepts EU-style when the last separator is a comma (e.g. `1.000,50`).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripThousandSeparators = stripThousandSeparators;
exports.normalizeMoneyInputString = normalizeMoneyInputString;
exports.parseMoneyInput = parseMoneyInput;
exports.coerceMoneyNumber = coerceMoneyNumber;
/** Strip thousand-separator commas from arithmetic expressions (`1,000+50` → `1000+50`). */
function stripThousandSeparators(raw) {
    let s = raw;
    let prev = "";
    while (s !== prev) {
        prev = s;
        s = s.replace(/(\d),(\d{3})(?!\d)/g, "$1$2");
    }
    return s;
}
/**
 * Normalize a typed/pasted money string to a plain `1234.56` form (no thousands separators).
 * Returns null when the value is not a finite money amount.
 */
function normalizeMoneyInputString(raw) {
    let s = raw.trim().replace(/\s/g, "");
    if (!s)
        return null;
    let sign = "";
    if (s.startsWith("-")) {
        sign = "-";
        s = s.slice(1);
    }
    else if (s.startsWith("+")) {
        s = s.slice(1);
    }
    if (!s)
        return null;
    const lastComma = s.lastIndexOf(",");
    const lastDot = s.lastIndexOf(".");
    if (lastComma >= 0 && lastDot >= 0) {
        if (lastComma > lastDot) {
            // EU: 1.000,50
            s = s.replace(/\./g, "").replace(",", ".");
        }
        else {
            // US/SG: 1,000.50
            s = s.replace(/,/g, "");
        }
    }
    else if (lastComma >= 0) {
        const parts = s.split(",");
        if (parts.length === 2 && /^\d+$/.test(parts[0]) && /^\d{1,2}$/.test(parts[1])) {
            // Decimal comma: 1000,50
            s = `${parts[0]}.${parts[1]}`;
        }
        else {
            // Thousand commas: 1,000 or 1,000,000
            s = s.replace(/,/g, "");
        }
    }
    if (!/^\d+(\.\d+)?$/.test(s))
        return null;
    return sign + s;
}
/** Parse a money field value (string or number) to a finite number, or null. */
function parseMoneyInput(value) {
    if (value == null || value === "")
        return null;
    if (typeof value === "number") {
        return Number.isFinite(value) ? value : null;
    }
    const normalized = normalizeMoneyInputString(String(value));
    if (normalized == null)
        return null;
    const n = Number(normalized);
    return Number.isFinite(n) ? n : null;
}
/** Coerce money input for totals/submit paths (`Number(x) || 0` replacement). */
function coerceMoneyNumber(value, fallback = 0) {
    const n = parseMoneyInput(value);
    return n == null ? fallback : n;
}
